import DataFactory from "../basic/data/DataFactory";
import {getModelFactory} from "../ModelFactory";

export const resetModeFactoryModelsPopulated = (): void =>
{
    for(let key in getModelFactory().basicModelFactories){
        const factory = getModelFactory().basicModelFactories[key];
        if(factory instanceof DataFactory){
            factory.resetPopulated()
        }
    }
}